import cx from 'classnames'
import styles from './style.styl'

const RadioOption = ({ className, style, children, selected, onClick }) => (
  <div className={cx(styles.RadioOption, className)} style={style}>
    <div className={cx("empty-circle", { selected })} onClick={onClick}>
      {selected && <div className="circle" />}
    </div>
    <div className="flex-1">
      {children}
    </div>
  </div>
)

export default RadioOption



// WEBPACK FOOTER //
// ./src/scripts/components/shared/RadioOption/index.js